(function () {
  'use strict';

  var MOBILE_QUERY = window.matchMedia('(max-width: 989px)');
  var instances = new WeakMap();

  function isMobile() {
    return MOBILE_QUERY.matches;
  }

  function lockScroll(lock) {
    document.documentElement.classList.toggle('tc-nav-lock', lock);
    document.body.classList.toggle('tc-nav-lock', lock);
  }

  function getMegaKey(element) {
    return element ? element.getAttribute('data-tc-mega-key') : null;
  }

  function setExpanded(item, expanded) {
    var trigger = item && item.querySelector(':scope > [data-tc-nav-trigger]');
    var submenu = item && item.querySelector(':scope > [data-tc-submenu]');

    if (trigger) trigger.setAttribute('aria-expanded', String(expanded));
    if (submenu) submenu.setAttribute('aria-hidden', String(!expanded));
  }

  /**
   * Render each Shopify child block once, then move its panel into the
   * dedicated panel container. This removes duplicated Shopify block IDs.
   */
  function prepareMegaLayouts(section) {
    section.querySelectorAll('[data-tc-mega-layout]').forEach(function (layout) {
      var tabs = layout.querySelector('[data-tc-mega-tabs]');
      var panels = layout.querySelector('[data-tc-mega-panels]');

      if (!tabs || !panels) return;

      tabs.querySelectorAll('[data-tc-mega-group]').forEach(function (group) {
        var panel = group.querySelector(':scope > [data-tc-mega-panel]');
        if (panel) panels.appendChild(panel);
      });
    });
  }

  function setActiveMegaByKey(layout, key) {
    if (!layout || !key) return;

    layout.querySelectorAll('[data-tc-mega-tab]').forEach(function (tab) {
      var active = getMegaKey(tab) === key;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
    });

    layout.querySelectorAll('[data-tc-mega-panel]').forEach(function (panel) {
      var active = getMegaKey(panel) === key;
      panel.classList.toggle('is-active', active);
      panel.setAttribute('aria-hidden', String(!active));
    });

    layout.querySelectorAll('[data-tc-mega-group]').forEach(function (group) {
      group.classList.toggle('is-active', getMegaKey(group) === key);
    });

    var activeTab = layout.querySelector('[data-tc-mega-tab].is-active span');
    var panelTitle = layout.querySelector('[data-tc-panel-title]');

    if (activeTab && panelTitle) {
      panelTitle.textContent = activeTab.textContent.trim();
    }
  }

  function activateFirstMegaGroup(scope) {
    scope.querySelectorAll('[data-tc-mega-layout]').forEach(function (layout) {
      var current = layout.querySelector('[data-tc-mega-tab].is-active');
      var first = layout.querySelector('[data-tc-mega-tabs] [data-tc-mega-tab]');
      var key = getMegaKey(current) || getMegaKey(first);

      if (key) setActiveMegaByKey(layout, key);
    });
  }

  function initNav(section) {
    var previousInstance = instances.get(section);
    if (previousInstance) previousInstance.destroy();

    prepareMegaLayouts(section);

    var controller = new AbortController();
    var signal = controller.signal;
    var toggle = section.querySelector('[data-tc-mobile-toggle]');
    var closeButton = section.querySelector('[data-tc-mobile-close]');
    var overlay = section.querySelector('[data-tc-nav-overlay]');
    var nav = section.querySelector('[data-tc-nav]');
    var topItems = Array.from(section.querySelectorAll('[data-tc-nav-item]'));
    var timers = new WeakMap();
    var lastModeWasMobile = isMobile();

    function clearTimer(item) {
      var timer = timers.get(item);
      if (!timer) return;

      window.clearTimeout(timer);
      timers.delete(item);
    }

    function closeTopItem(item) {
      clearTimer(item);
      item.classList.remove('is-open', 'is-submenu-open');
      setExpanded(item, false);
    }

    function closeAllTopItems(exceptItem) {
      topItems.forEach(function (item) {
        if (item !== exceptItem) closeTopItem(item);
      });

      section.querySelectorAll('[data-tc-mega-layout].is-mobile-panel-open').forEach(function (layout) {
        layout.classList.remove('is-mobile-panel-open');
      });

      if (!exceptItem) section.classList.remove('is-mobile-submenu-active');
    }

    function openTopItem(item, submenuMode) {
      if (!item) return;

      closeAllTopItems(item);
      clearTimer(item);
      item.classList.add('is-open');

      if (submenuMode) {
        item.classList.add('is-submenu-open');
        section.classList.add('is-mobile-submenu-active');
      }

      setExpanded(item, true);
      activateFirstMegaGroup(item);
    }

    function closeMobilePanel(button) {
      var layout = button.closest('[data-tc-mega-layout]');
      if (layout) layout.classList.remove('is-mobile-panel-open');
    }

    function closeMobileSubmenu() {
      topItems.forEach(function (item) {
        closeTopItem(item);
      });

      section.classList.remove('is-mobile-submenu-active');
    }

    function openMobile() {
      if (!isMobile()) return;

      section.classList.add('is-mobile-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (nav) nav.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      activateFirstMegaGroup(section);

      window.requestAnimationFrame(function () {
        if (closeButton) closeButton.focus({ preventScroll: true });
      });
    }

    function closeMobile(options) {
      var restoreFocus = !options || options.restoreFocus !== false;

      section.classList.remove('is-mobile-open', 'is-mobile-submenu-active');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (nav && isMobile()) nav.setAttribute('aria-hidden', 'true');

      closeAllTopItems();
      lockScroll(false);

      if (restoreFocus && toggle && isMobile()) {
        window.requestAnimationFrame(function () {
          toggle.focus({ preventScroll: true });
        });
      }
    }

    function syncMode(force) {
      var mobile = isMobile();
      if (!force && mobile === lastModeWasMobile) return;

      lastModeWasMobile = mobile;
      closeMobile({ restoreFocus: false });

      if (nav) {
        nav.setAttribute('aria-hidden', mobile ? 'true' : 'false');
      }

      if (!mobile) {
        section.classList.remove('is-mobile-open', 'is-mobile-submenu-active');
      }

      activateFirstMegaGroup(section);
    }

    if (toggle) {
      toggle.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();

          if (section.classList.contains('is-mobile-open')) {
            closeMobile();
          } else {
            openMobile();
          }
        },
        { signal: signal }
      );
    }

    if (closeButton) {
      closeButton.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          closeMobile();
        },
        { signal: signal }
      );
    }

    if (overlay) {
      overlay.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          closeMobile();
        },
        { signal: signal }
      );
    }

    if (nav) {
      nav.addEventListener(
        'click',
        function (event) {
          var target = event.target;
          if (!(target instanceof Element)) return;

          var panelBack = target.closest('[data-tc-panel-back]');
          if (panelBack) {
            event.preventDefault();
            event.stopPropagation();
            closeMobilePanel(panelBack);
            return;
          }

          var submenuBack = target.closest('[data-tc-submenu-back]');
          if (submenuBack) {
            event.preventDefault();
            event.stopPropagation();
            closeMobileSubmenu();
            return;
          }

          var tab = target.closest('[data-tc-mega-tab]');
          if (tab) {
            event.preventDefault();
            event.stopPropagation();

            var layout = tab.closest('[data-tc-mega-layout]');
            setActiveMegaByKey(layout, getMegaKey(tab));

            if (isMobile() && layout) {
              layout.classList.add('is-mobile-panel-open');
            }
            return;
          }

          var trigger = target.closest('[data-tc-nav-trigger]');
          if (!trigger || !isMobile()) return;

          var item = trigger.closest('[data-tc-nav-item]');
          var submenu = item && item.querySelector(':scope > [data-tc-submenu]');
          if (!item || !submenu) return;

          event.preventDefault();
          event.stopPropagation();
          openTopItem(item, true);
        },
        { signal: signal }
      );

      nav.addEventListener(
        'pointerover',
        function (event) {
          if (isMobile()) return;

          var target = event.target;
          if (!(target instanceof Element)) return;

          var tab = target.closest('[data-tc-mega-tab]');
          if (!tab) return;

          var layout = tab.closest('[data-tc-mega-layout]');
          setActiveMegaByKey(layout, getMegaKey(tab));
        },
        { signal: signal }
      );
    }

    topItems.forEach(function (item) {
      var submenu = item.querySelector(':scope > [data-tc-submenu]');
      if (!submenu) return;

      item.addEventListener(
        'pointerenter',
        function () {
          if (isMobile()) return;
          openTopItem(item, false);
        },
        { signal: signal }
      );

      item.addEventListener(
        'pointerleave',
        function () {
          if (isMobile()) return;

          clearTimer(item);
          var timer = window.setTimeout(function () {
            closeTopItem(item);
            timers.delete(item);
          }, 180);

          timers.set(item, timer);
        },
        { signal: signal }
      );
    });

    document.addEventListener(
      'keydown',
      function (event) {
        if (event.key !== 'Escape') return;

        if (section.querySelector('[data-tc-mega-layout].is-mobile-panel-open')) {
          section.querySelectorAll('[data-tc-mega-layout].is-mobile-panel-open').forEach(function (layout) {
            layout.classList.remove('is-mobile-panel-open');
          });
          return;
        }

        if (section.classList.contains('is-mobile-submenu-active')) {
          closeMobileSubmenu();
          return;
        }

        closeMobile();
      },
      { signal: signal }
    );

    // Do not close the menu on every mobile browser resize. Dynamic address-bar
    // changes can fire resize repeatedly and previously made taps appear broken.
    MOBILE_QUERY.addEventListener('change', syncMode, { signal: signal });

    syncMode(true);
    activateFirstMegaGroup(section);

    instances.set(section, {
      destroy: function () {
        controller.abort();
        closeMobile({ restoreFocus: false });
        instances.delete(section);
      }
    });
  }

  function initWithin(root) {
    if (root.matches && root.matches('[data-tc-nav-section]')) {
      initNav(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('[data-tc-nav-section]').forEach(initNav);
    }
  }

  function start() {
    initWithin(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector
      ? event.target.querySelector('[data-tc-nav-section]')
      : null;

    var instance = section && instances.get(section);
    if (instance) instance.destroy();
  });
})();

/* =========================================
   Tucoiva cart count synchronization
========================================= */

(function () {
  'use strict';

  if (window.__tucoivaCartCountSync) return;

  var CART_COUNT_SELECTOR = '[data-tc-cart-count]';
  var CART_LINK_SELECTOR = '[data-tc-cart-link]';
  var CART_MUTATION_PATTERN = /\/cart\/(add|change|update|clear)(?:\.js)?(?:[?#]|$)/i;
  var updateTimer = null;
  var xhrUrlMap = new WeakMap();

  function getShopifyRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;

    if (typeof root !== 'string' || root.length === 0) return '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function normalizeRequestUrl(input) {
    if (typeof input === 'string') return input;
    if (typeof URL !== 'undefined' && input instanceof URL) return input.href;
    if (typeof Request !== 'undefined' && input instanceof Request) return input.url;
    return '';
  }

  function isCartMutationUrl(url) {
    return CART_MUTATION_PATTERN.test(String(url || ''));
  }

  function renderCartCount(itemCount) {
    var count = Number(itemCount) || 0;
    var visibleCount = count > 99 ? '99+' : String(count);

    document.querySelectorAll(CART_COUNT_SELECTOR).forEach(function (element) {
      element.textContent = visibleCount;
      element.classList.toggle('is-hidden', count === 0);
    });

    document.querySelectorAll(CART_LINK_SELECTOR).forEach(function (link) {
      link.setAttribute('aria-label', count > 0 ? 'Cart, ' + count + ' items' : 'Cart');
    });
  }

  function fetchCart() {
    return window.fetch(getShopifyRoot() + 'cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      },
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart request failed with status ' + response.status);
      }

      return response.json();
    });
  }

  function updateCartCount() {
    if (!document.querySelector(CART_COUNT_SELECTOR)) {
      return Promise.resolve(null);
    }

    return fetchCart()
      .then(function (cart) {
        renderCartCount(cart.item_count);
        return cart;
      })
      .catch(function (error) {
        console.error('[Tucoiva Custom Nav] Unable to update cart count:', error);
        return null;
      });
  }

  function scheduleCartCountUpdate(delay) {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(updateCartCount, typeof delay === 'number' ? delay : 80);
  }

  function installFetchListener() {
    if (typeof window.fetch !== 'function' || window.fetch.__tucoivaCartWrapped) return;

    var originalFetch = window.fetch;

    function wrappedFetch() {
      var requestUrl = normalizeRequestUrl(arguments[0]);
      var requestPromise = originalFetch.apply(this, arguments);

      if (!isCartMutationUrl(requestUrl)) return requestPromise;

      return requestPromise.then(function (response) {
        if (response && response.ok) scheduleCartCountUpdate(60);
        return response;
      });
    }

    wrappedFetch.__tucoivaCartWrapped = true;
    wrappedFetch.__tucoivaOriginalFetch = originalFetch;
    window.fetch = wrappedFetch;
  }

  function installXhrListener() {
    if (!window.XMLHttpRequest || XMLHttpRequest.prototype.open.__tucoivaCartWrapped) return;

    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      xhrUrlMap.set(this, normalizeRequestUrl(url));
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.open.__tucoivaCartWrapped = true;

    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      var requestUrl = xhrUrlMap.get(xhr);

      if (isCartMutationUrl(requestUrl)) {
        xhr.addEventListener(
          'loadend',
          function () {
            if (xhr.status >= 200 && xhr.status < 400) scheduleCartCountUpdate(60);
          },
          { once: true }
        );
      }

      return originalSend.apply(this, arguments);
    };
  }

  function installFormListener() {
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        var action = form.getAttribute('action') || '';
        if (isCartMutationUrl(action)) scheduleCartCountUpdate(350);
      },
      true
    );
  }

  function installThemeEventListeners() {
    [
      'cart:updated',
      'cart:change',
      'cart:refresh',
      'cart:build',
      'product:added',
      'ajaxProduct:added',
      'theme:cart:change'
    ].forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        scheduleCartCountUpdate(40);
      });

      window.addEventListener(eventName, function () {
        scheduleCartCountUpdate(40);
      });
    });
  }

  function startCartCountSync() {
    installFetchListener();
    installXhrListener();
    installFormListener();
    installThemeEventListeners();
    updateCartCount();
  }

  window.__tucoivaCartCountSync = {
    update: updateCartCount,
    render: renderCartCount
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCartCountSync, { once: true });
  } else {
    startCartCountSync();
  }

  window.addEventListener('pageshow', function () {
    scheduleCartCountUpdate(0);
  });

  document.addEventListener('shopify:section:load', function () {
    scheduleCartCountUpdate(0);
  });
})();
